import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { ConfigurationRouteViewComponent } from '../pages/configuration-route-view/configuration-route-view.component';

@EnableClassTelemetry()
@Injectable()
export class CanDeactivateConfigurationRouteEditService {
  canDeactivate(component: ConfigurationRouteViewComponent): Promise<boolean> {
    return new Promise(async (resolve) => {
      if (component.configRouteEditTab?.hasChanges) {
        const promise = new Promise((innerResolve) =>
          component.configRouteEditTab.checkChanges(innerResolve)
        );
        const res = await promise;
        return resolve(res as boolean);
      } else {
        resolve(true);
      }
    });
  }
}
